import { mapState, mapGetters, mapMutations } from "vuex";
export default {
	data() {
		return {
			//必须重载这个
			// dataModelName: "NULL",
			// 或这个
			//dataModelNames:["A","B"]
		};
	},

	computed: {
		...mapState(["dataModels", "loadingDM"]),
		hasGetTableDataModel() {
			if (this.dataModelNames) {
				return this.dataModelNames.every(val => {
					return this.dataModels[val] && this.dataModels[val]._id;
				});
			}
			if (this.dataModelName) {
				if (this.dataModels[this.dataModelName] && this.dataModels[this.dataModelName]._id) {
					return true;
				} else {
					return false;
				}
			}
		}
	},
	mounted() {
		if (this.dataModelName && this.dataModelName != "NULL") {
			this.checkDataModel(this.dataModelName);
		}
		if (this.dataModelNames) {
			this.dataModelNames.forEach(val => {
				this.checkDataModel(val);
			});
		}
	},
	methods: {
		...mapMutations(["checkDataModel"]),
		initInfo(data) {
			this.fields.forEach(field => {
				if (field.name == "null") {
					return;
				}

				let initV;
				if (data && field.name in data) {
					initV = data[field.name];
				} else if (this.defaultValue && this.defaultValue[field.name]) {
					initV = this.defaultValue[field.name];
				} else if (
					this.dataModels[this.dataModelName] &&
					this.dataModels[this.dataModelName][field.name] &&
					this.dataModels[this.dataModelName][field.name].default
				) {
					initV = this.dataModels[this.dataModelName][field.name].default;
				} else {
					return;
				}
				this.$set(this.info, field.name, JSON.parse(JSON.stringify(initV)));
			});
		}
	},
	hasGetTableDataModel: {
		handler(val) {
			if (val && this.info) {
				this.initInfo();
			}
		},
		immediate: true
	}
};
